import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'queue' },
  {
    path: 'invite/:token',
    loadComponent: () =>
      import('./features/auth/invite-landing.component').then(m => m.InviteLandingComponent)
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./features/auth/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'queue',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/queue/queue.component').then(m => m.QueueComponent)
  },
  {
    path: 'studio/:taskId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/studio/studio.component').then(m => m.StudioComponent)
  },
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/profile/profile.component').then(m => m.ProfileComponent)
  },
  {
    path: 'article-proof/:token',
    // Public — author has no Studio account
    loadComponent: () =>
      import('./features/proof/article-proof-page.component').then(m => m.ArticleProofPageComponent)
  },
  {
    // Unified review route used by BOTH:
    //   - the proof reader logged into studio (no token; component fetches via
    //     studio JWT / task-id endpoint), AND
    //   - the author following a token link from their email
    //     (/review/:taskId?token=… — token query param; no studio login needed).
    //
    // The component (ArticleProofPageComponent) inspects the route + query
    // params to pick the right fetch path. No guard here — the data endpoints
    // enforce their own auth (JWT or token).
    path: 'review/:taskId',
    loadComponent: () =>
      import('./features/proof/article-proof-page.component').then(m => m.ArticleProofPageComponent)
  },
  { path: '**', redirectTo: 'queue' }
];
